"use client";

import { useEffect } from "react";
import { publicBrowserTools, type BrowserTool, type PublicCategory } from "@/lib/agentic/tools";

type ModelContext = { registerTool: (tool: BrowserTool, options: { signal: AbortSignal }) => Promise<void> };

/** Progressive enhancement: supported browsers use the native API; ordinary browsing is unchanged. */
export function WebMcpTools({ categories }: { categories: PublicCategory[] }) {
  useEffect(() => {
    const context = (document as Document & { modelContext?: ModelContext }).modelContext;
    if (!window.isSecureContext || !context?.registerTool) return;
    const controller = new AbortController();
    void (async () => {
      for (const tool of publicBrowserTools(categories, location.origin)) {
        if (controller.signal.aborted) return;
        await context.registerTool(tool, { signal: controller.signal });
      }
    })().catch(() => { if (!controller.signal.aborted) console.warn("Codifly public WebMCP tools could not be registered."); });
    return () => controller.abort();
  }, [categories]);
  return null;
}
